export const AdminApiPath = {
  RETRAIN: '/api/admin/retrain' // POST Retrain all models
}

export type AdminApiPath = (typeof AdminApiPath)[keyof typeof AdminApiPath]

export interface RetrainVars {}

export interface RetrainResponse {
  status: string
  message?: string
}
